import React from "react";
import { Grid, Paper, Container, SxProps, Theme } from "@mui/material";
import PageWithLoad from "../progress/PageWithLoad";

interface IProps {
  top: any;
  aside: any;
  children: any;
  fullWidth?: boolean;
  isLoading?: boolean;
}

export default function TwoColAside(props: IProps) {
  const {
    top,
    aside,
    children,
    fullWidth,
    isLoading,
  } = props;

  const containerProps: SxProps<Theme> | undefined = fullWidth
    ? {
        maxWidth: { xs: "100%", md: "100%", lg: "100%", xl: "100%" },
      }
    : {
        maxWidth: { xs: "100%", md: "90%", lg: "75%", xl: "70%" },
      };

  return (
    <PageWithLoad loading={isLoading ?? false}>
      <Container sx={containerProps}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper variant="paper">
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  {top}
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item>
                  {aside}
                </Grid>
                <Grid item xs>
                  {children}
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </PageWithLoad>
  );
}
